import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

// Fetch email status
export const getEmailStatus = async (jobApplicantId) => {
  try {
    const response = await axiosInstance.get(API.hiringJobApplicant.getEmailStatus(jobApplicantId));
    return response.data;
  } catch (error) {
    console.error("Error fetching email status:", error);
    throw error;
  }
};

// Submit onboarding data
export const submitOnboardingData = async (payload) => {
  try {
    const response = await axiosInstance.post(API.hiringOnboardings.addOnboarding, payload);

    if (!(response.status >= 200 && response.status < 300)) {
      throw new Error("Failed to add onboarding data");
    }

    return response;
  } catch (error) {
    console.error("Error submitting onboarding data:", error);
    throw error;
  }
};
